import { render } from "./MessageViewModal.vue?vue&type=template&id=935d73d4&scoped=true&ts=true"
import script from "./MessageViewModal.vue?vue&type=script&lang=ts"
export * from "./MessageViewModal.vue?vue&type=script&lang=ts"

import "./MessageViewModal.vue?vue&type=style&index=0&id=935d73d4&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935d73d4"]])

export default __exports__